// @ts-check
import { useCallback, useState } from 'preact/hooks';

/**
 * @returns {[import('../types').Shape[], (shapes: import('../types').Shape[]) => void, { shapeSelected: import('../types').Shape | null, shapeHover: import('../types').ShapeWithBBox | null, handleShapeClick: (shapeId: string, bBox: SVGRect) => void ,handleShapeMouseEnter: (shapeId: string, bBox: SVGRect) => void, handleShapeMouseLeave: (shapeId: string, bBox: SVGRect) => void }]}
 */
export default function useSvgMap() {
	const [shapes, setShapes] = useState([]);
	const [shapeSelected, setShapeSelected] = useState(null);
	const [shapeHover, setShapeHover] = useState(null);

	const handleShapeClick = useCallback((shapeId) => {
		setShapeSelected(shapes.find(shape => shape.id === shapeId) || null);
	}, [shapes]);

	const handleShapeMouseEnter = useCallback((shapeId, bBox) => {
		const foundShape = shapes.find(shape => shape.id === shapeId);
		setShapeHover(foundShape ? { ...foundShape, bBox } : null);
	}, [shapes]);

	const handleShapeMouseLeave = useCallback(() => {
		setShapeHover(null);
	}, []);

	return [shapes, setShapes, { shapeSelected, shapeHover, handleShapeClick, handleShapeMouseEnter, handleShapeMouseLeave }];
}
